export const COMPONENT_NAME = "wallet-applications";
